import { PRECIOS_ANUNCIADOS_CLP, precioClp } from './productosPlus.js';

export const VERSION_PRUEBA_TARJETA = '2026-10-27-tarjeta-v1';
export const DIAS_PRUEBA_TARJETA = Object.freeze({ plus_estudiante: 3, plus_enfermero: 7 });
export function condicionesPruebaTarjeta(producto) {
  const dias = DIAS_PRUEBA_TARJETA[producto];
  if (!dias) return null;
  return `Registra tu tarjeta para iniciar ${dias} días de prueba gratuita. Al terminar se cobrará automáticamente ${precioClp(PRECIOS_ANUNCIADOS_CLP[producto])} CLP (IVA incluido) y la membresía se renovará cada mes por ese monto. Puedes cancelar antes del primer cobro desde Mi perfil en la web. Las pruebas anteriores mantienen sus condiciones.`;
}
